module.exports = __webpack_public_path__ + "static/media/0-01.d38d9d54.png";